import { useRef, useState, type ChangeEvent } from 'react';
import { Button } from '../../../design-system/components/Button';
import { Select } from '../../../design-system/components/Select';
import { useUploadKnowledge } from '../hooks';
import {
  KNOWLEDGE_ALLOWED_EXTENSIONS,
  KNOWLEDGE_DOC_TYPE_OPTIONS,
  validateKnowledgeFile,
  type KnowledgeDocType,
} from '../status';

export function UploadZoneWeb() {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [docType, setDocType] = useState<KnowledgeDocType>('battlecard');
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const mutation = useUploadKnowledge();

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file === undefined) return;
    const validation = validateKnowledgeFile(file);
    if (!validation.ok) {
      setError(validation.message ?? 'Arquivo inválido.');
      setMessage(null);
      e.target.value = '';
      return;
    }
    setError(null);
    try {
      const doc = await mutation.mutateAsync({
        file,
        filename: file.name,
        doc_type: docType,
      });
      setMessage(`Arquivo "${doc.filename}" enviado. Status: pendente.`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Falha no upload.');
    } finally {
      e.target.value = '';
    }
  };

  const options = KNOWLEDGE_DOC_TYPE_OPTIONS.filter((o) => o.value !== '') as {
    value: KnowledgeDocType;
    label: string;
  }[];

  return (
    <div className="dash-upload">
      <Select
        label="Categoria"
        options={options}
        value={docType}
        onChange={(e) => setDocType(e.target.value as KnowledgeDocType)}
      />
      <input
        ref={inputRef}
        type="file"
        accept={KNOWLEDGE_ALLOWED_EXTENSIONS.join(',')}
        onChange={handleChange}
        className="dash-upload__input"
        aria-label="Selecionar arquivo"
      />
      <Button
        variant="primary"
        onClick={() => inputRef.current?.click()}
        isLoading={mutation.isPending}
      >
        Enviar arquivo
      </Button>
      {error !== null ? (
        <p className="login-error" role="alert">
          {error}
        </p>
      ) : null}
      {message !== null ? (
        <p className="muted" role="status">
          {message}
        </p>
      ) : null}
    </div>
  );
}
